// 线上环境配置 正式地址域名
module.exports = {
  title: "中国话语与世界文学研究中心",
  APPID: "xxx",
  APPSECRET: "xxx",
  projectFileUrl: "/cms", // 文件请求路径
};